module.exports = __webpack_public_path__ + "img/icon41.126a44c3.png";